/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CommunicationInfo,
    CommunicationInfoFromJSON,
    CommunicationInfoFromJSONTyped,
    CommunicationInfoToJSON,
    CommunicationStatus,
    CommunicationStatusFromJSON,
    CommunicationStatusFromJSONTyped,
    CommunicationStatusToJSON,
    CommunicationType,
    CommunicationTypeFromJSON,
    CommunicationTypeFromJSONTyped,
    CommunicationTypeToJSON,
    ExternalCommunicationItem,
    ExternalCommunicationItemFromJSON,
    ExternalCommunicationItemFromJSONTyped,
    ExternalCommunicationItemToJSON,
    ObjectTypeEnum,
    ObjectTypeEnumFromJSON,
    ObjectTypeEnumFromJSONTyped,
    ObjectTypeEnumToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExternalCommunication
 */
export interface ExternalCommunication {
    /**
     * 
     * @type {string}
     * @memberof ExternalCommunication
     */
    id?: string;
    /**
     * 
     * @type {ObjectTypeEnum}
     * @memberof ExternalCommunication
     */
    objectType: ObjectTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ExternalCommunication
     */
    objectId: string;
    /**
     * 
     * @type {CommunicationType}
     * @memberof ExternalCommunication
     */
    communicationType: CommunicationType;
    /**
     * 
     * @type {CommunicationStatus}
     * @memberof ExternalCommunication
     */
    status: CommunicationStatus;
    /**
     * 
     * @type {CommunicationInfo}
     * @memberof ExternalCommunication
     */
    communicationInfo: CommunicationInfo;
    /**
     * 
     * @type {string}
     * @memberof ExternalCommunication
     */
    firmId: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalCommunication
     */
    caseId: string;
    /**
     * 
     * @type {Date}
     * @memberof ExternalCommunication
     */
    createdDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ExternalCommunication
     */
    lastActivityDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalCommunication
     */
    createdBy: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalCommunication
     */
    alternateCreatedBy?: string | null;
    /**
     * 
     * @type {ObjectTypeEnum}
     * @memberof ExternalCommunication
     */
    sharedWithObjectType?: ObjectTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ExternalCommunication
     */
    sharedWithObjectId?: string | null;
    /**
     * 
     * @type {Array<ExternalCommunicationItem>}
     * @memberof ExternalCommunication
     */
    externalCommunicationItems?: Array<ExternalCommunicationItem> | null;
}

export function ExternalCommunicationFromJSON(json: any): ExternalCommunication {
    return ExternalCommunicationFromJSONTyped(json, false);
}

export function ExternalCommunicationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalCommunication {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'objectType': ObjectTypeEnumFromJSON(json['objectType']),
        'objectId': json['objectId'],
        'communicationType': CommunicationTypeFromJSON(json['communicationType']),
        'status': CommunicationStatusFromJSON(json['status']),
        'communicationInfo': CommunicationInfoFromJSON(json['communicationInfo']),
        'firmId': json['firmId'],
        'caseId': json['caseId'],
        'createdDate': (new Date(json['createdDate'])),
        'lastActivityDate': !exists(json, 'lastActivityDate') ? undefined : (json['lastActivityDate'] === null ? null : new Date(json['lastActivityDate'])),
        'createdBy': json['createdBy'],
        'alternateCreatedBy': !exists(json, 'alternateCreatedBy') ? undefined : json['alternateCreatedBy'],
        'sharedWithObjectType': !exists(json, 'sharedWithObjectType') ? undefined : ObjectTypeEnumFromJSON(json['sharedWithObjectType']),
        'sharedWithObjectId': !exists(json, 'sharedWithObjectId') ? undefined : json['sharedWithObjectId'],
        'externalCommunicationItems': !exists(json, 'externalCommunicationItems') ? undefined : (json['externalCommunicationItems'] === null ? null : (json['externalCommunicationItems'] as Array<any>).map(ExternalCommunicationItemFromJSON)),
    };
}

export function ExternalCommunicationToJSON(value?: ExternalCommunication | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'objectType': ObjectTypeEnumToJSON(value.objectType),
        'objectId': value.objectId,
        'communicationType': CommunicationTypeToJSON(value.communicationType),
        'status': CommunicationStatusToJSON(value.status),
        'communicationInfo': CommunicationInfoToJSON(value.communicationInfo),
        'firmId': value.firmId,
        'caseId': value.caseId,
        'createdDate': (value.createdDate.toISOString()),
        'lastActivityDate': value.lastActivityDate === undefined ? undefined : (value.lastActivityDate === null ? null : value.lastActivityDate.toISOString()),
        'createdBy': value.createdBy,
        'alternateCreatedBy': value.alternateCreatedBy,
        'sharedWithObjectType': ObjectTypeEnumToJSON(value.sharedWithObjectType),
        'sharedWithObjectId': value.sharedWithObjectId,
        'externalCommunicationItems': value.externalCommunicationItems === undefined ? undefined : (value.externalCommunicationItems === null ? null : (value.externalCommunicationItems as Array<any>).map(ExternalCommunicationItemToJSON)),
    };
}


